import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface ConcreteVRIconProps {
  size?: number;
  color?: string;
}

const ConcreteVRIcon: React.FC<ConcreteVRIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-concretevr">
    {
      <path d="M18.787 2.902h-13.573c-0.049 0 1.091 18.195 1.091 18.195l11.371-0.129c0.049 0 1.116-18.049 1.11-18.067z"></path>

    }  </SvgIcon>
);

export default ConcreteVRIcon;
